import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13a40edc")

_pushScopeId("data-v-13a40edc")
const _hoisted_1 = { class: "onetrip-page" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "infoLoad" }, "Идет загрузка данных !", -1)
const _hoisted_4 = {
  key: 1,
  class: "container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubHeader = _resolveComponent("SubHeader")
  const _component_left_filter_type_offers = _resolveComponent("left-filter-type-offers")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SubHeader, {
      title: _ctx.title,
      isMain: false,
      subText: _ctx.subText,
      canClose: true,
      canCreate: false
    }, null, 8, ["title", "subText"]),
    (!_ctx.activeOrderIsLoad && !_ctx.isLoadData)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeOrderIsLoad && _ctx.isLoadData)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_left_filter_type_offers),
          _createVNode(_component_router_view, {
            listOrders: _ctx.listOrders,
            initData: _ctx.initData
          }, null, 8, ["listOrders", "initData"])
        ]))
      : _createCommentVNode("", true)
  ]))
})